const LOCALES: ILocales = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'de',
    name: 'Deutsch',
  },
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'es',
    name: 'Español',
  },
  {
    code: 'it',
    name: 'Italiano',
  },
  {
    code: 'pt',
    name: 'Português',
  },
  {
    code: 'tr',
    name: 'Türkçe',
  },
  {
    code: 'ko',
    name: '한국어',
  },
  {
    code: 'ru',
    name: 'Русский',
  },
  {
    code: 'fa',
    name: 'فارسی',
  },
]

export default LOCALES

export const localesWithoutKorean: TLocaleCode[] = ['en', 'de', 'fr', 'es', 'it', 'pt', 'tr']

export interface ILocale {
  code: TLocaleCode
  name: string
}

export type TLocaleCode = 'en' | 'de' | 'fr' | 'es' | 'it' | 'pt' | 'tr' | 'ko' | 'ru' | 'fa'

export type ILocales = Array<ILocale>
